import React, { useEffect, useState, useRef } from 'react'
import { NextOutline } from '@carbon/icons-react'
import HeaderTileItem from './HeaderTileItem'
const HeaderCarousel = (props) => {
  const {
    completed,
    isActive,
    smartTileData,
    sourceItem,
    audioPlaying,
    onAudioClicked,
    selectedIndex,
    shuffledArray,
    onSkipClick,
    isAudioPlaying
  } = props

  const [headerShuffledArray, setHeaderShuffledArray] = useState([])
  const [topFirstItem, setTopFirstItem] = useState({})
  const [topSecondItem, setTopSecondItem] = useState({})
  const [bottomFirstItem, setBottomFirstItem] = useState({})
  const [bottomSecondItem, setBottomSecondItem] = useState({})
  const [selectedItem, setSelectedItem] = useState({})
  const [isAnimation, setIsAnimation] = useState(false)
  const [animationDirection, setAnimationDirection] = useState('top')
  const [isArrowClick, setIsArrowClick] = useState(false)

  useEffect(() => {
    if (shuffledArray.length > 0) {
      let filteredData = shuffledArray.filter((e) => e.disabled !== true)
      setHeaderShuffledArray(filteredData)
    }
  }, [shuffledArray])

  useEffect(() => {
    if (shuffledArray.length > 0) {
      //set active header item
      // let selectedItemCopy = headerShuffledArray[selectedIndex]
      let selectedItemCopy = shuffledArray[selectedIndex]
      setSelectedItem(selectedItemCopy)
      //set first and second bottom item
      let bottomFirstItemCopy = {}
      let bottomSecondItemCopy = {}
      if (selectedIndex < shuffledArray.length - 1) {
        //if active header is less then total shuffled array
        bottomFirstItemCopy = shuffledArray[selectedIndex + 1]
        if (shuffledArray[selectedIndex + 2]) {
          bottomSecondItemCopy = shuffledArray[selectedIndex + 2]
        } else {
          // bottomSecondItemCopy = shuffledArray[0]
        }
      } else if (selectedIndex === shuffledArray.length - 1) {
        //if active header is equal to total shuffled array
        bottomFirstItemCopy = shuffledArray[0]
        bottomSecondItemCopy = shuffledArray[1]
      }
      setBottomFirstItem(bottomFirstItemCopy)
      setBottomSecondItem(bottomSecondItemCopy)
      //set first and second top item
      let topFirstItemCopy = {}
      let topSecondItemCopy = {}
      if (selectedIndex === 0) {
        topFirstItemCopy = shuffledArray[shuffledArray.length - 1]
        topSecondItemCopy = shuffledArray[shuffledArray.length - 2]
      } else if (selectedIndex > 0) {
        topFirstItemCopy = shuffledArray[selectedIndex - 1]
        if (shuffledArray[selectedIndex - 2]) {
          topSecondItemCopy = shuffledArray[selectedIndex - 2]
        } else {
          // topSecondItemCopy = shuffledArray[shuffledArray.length - 1]
        }
      }
      setTopFirstItem(topFirstItemCopy)
      setTopSecondItem(topSecondItemCopy)
      setIsAnimation(true)
      if (!isArrowClick) {
        setAnimationDirection('top')
      }
      setTimeout(() => {
        setIsAnimation(false)
        setIsArrowClick(false)
      }, 300)
    }
  }, [selectedIndex, shuffledArray])

  if (headerShuffledArray.length > 0) {
    return (
      <div className='tile-carousel-cont'>
        <div
          className={
            isArrowClick && animationDirection === 'top'
              ? 'header-arrow-container bg-yellow'
              : 'header-arrow-container bg-brand'
          }
          onClick={() => {
            if (completed === 0 && isActive && !isAudioPlaying) {
              onSkipClick('top')
              setAnimationDirection('top')
              setIsArrowClick(true)
            }
          }}
        >
          <NextOutline className='header-arrow-up-icon' />
        </div>
        <div className='carousel-top-cont'>
          <div className='carousel-center-cont'>
            <div className='carousel-item-selected'>
              <div
                className={
                  isAnimation
                    ? 'carousel-item-selected-sub bg-blue'
                    : 'carousel-item-selected-sub bg-blue'
                }
              >
                <HeaderTileItem
                  smartTileData={smartTileData}
                  sourceItem={selectedItem}
                  isAnimation={isAnimation}
                  animationDirection={animationDirection}
                  audioPlaying={audioPlaying}
                  onAudioClicked={() => {
                    if (completed === 0 && isActive) {
                      onAudioClicked()
                    }
                  }}
                  isCeneterTile={true}
                />
              </div>
            </div>
          </div>
          {shuffledArray.length > 0 &&
            shuffledArray.map((headerTileItem, headertileIndex) => {
              if (
                !headerTileItem.disabled &&
                selectedIndex !== headertileIndex
              ) {
                return (
                  <div className='carousel-item-cont'>
                    <HeaderTileItem
                      smartTileData={smartTileData}
                      sourceItem={headerTileItem}
                      isAnimation={isAnimation}
                      animationDirection={animationDirection}
                    />
                  </div>
                )
              }
            })}
        </div>
        <div
          className={
            isArrowClick && animationDirection === 'bottom'
              ? 'header-arrow-container bg-yellow'
              : 'header-arrow-container bg-brand'
          }
          onClick={() => {
            if (completed === 0 && isActive && !isAudioPlaying) {
              onSkipClick('bottom')
              setAnimationDirection('bottom')
              setIsArrowClick(true)
            }
          }}
        >
          <NextOutline className='header-arrow-down-icon' />
        </div>
      </div>
    )
  } else {
    return null
  }

  // return (
  //   <div className='tile-carousel-cont'>
  //     <div
  //       className={
  //         isArrowClick && animationDirection === 'top'
  //           ? 'header-arrow-container bg-yellow'
  //           : 'header-arrow-container bg-brand'
  //       }
  //       onClick={() => {
  //         if (completed === 0 && isActive && !isAudioPlaying) {
  //           onSkipClick('top')
  //           setAnimationDirection('top')
  //           setIsArrowClick(true)
  //         }
  //       }}
  //     >
  //       <NextOutline className='header-arrow-up-icon' />
  //     </div>
  //     <div className='carousel-top-cont'>
  //       <div
  //         className='carousel-item-small-cont'
  //         style={{ display: shuffledArray.length > 4 ? 'flex' : 'none' }}
  //       >
  //         <HeaderTileItem
  //           smartTileData={smartTileData}
  //           sourceItem={topSecondItem}
  //           isAnimation={isAnimation}
  //           animationDirection={animationDirection}
  //         />
  //       </div>
  //       <div
  //         className='carousel-item-cont'
  //         style={{ display: shuffledArray.length > 3 ? 'flex' : 'none' }}
  //       >
  //         <HeaderTileItem
  //           smartTileData={smartTileData}
  //           sourceItem={topFirstItem}
  //           isAnimation={isAnimation}
  //           animationDirection={animationDirection}
  //         />
  //       </div>
  //     </div>
  //     <div className='carousel-center-cont'>
  //       <div className='carousel-item-selected'>
  //         <div
  //           className={
  //             isAnimation
  //               ? 'carousel-item-selected-sub bg-blue'
  //               : 'carousel-item-selected-sub bg-yellow'
  //           }
  //         >
  //           <HeaderTileItem
  //             smartTileData={smartTileData}
  //             sourceItem={selectedItem}
  //             isAnimation={isAnimation}
  //             animationDirection={animationDirection}
  //             audioPlaying={audioPlaying}
  //             onAudioClicked={() => {
  //               if (completed === 0 && isActive) {
  //                 onAudioClicked()
  //               }
  //             }}
  //             isCeneterTile={true}
  //           />
  //         </div>
  //       </div>
  //     </div>
  //     <div className='carousel-bottom-cont'>
  //       <div className='carousel-item-cont'>
  //         <HeaderTileItem
  //           smartTileData={smartTileData}
  //           sourceItem={bottomFirstItem}
  //           isAnimation={isAnimation}
  //           animationDirection={animationDirection}
  //         />
  //       </div>
  //       <div
  //         className='carousel-item-small-cont'
  //         style={{ display: shuffledArray.length > 2 ? 'flex' : 'none' }}
  //       >
  //         <HeaderTileItem
  //           smartTileData={smartTileData}
  //           sourceItem={bottomSecondItem}
  //           isAnimation={isAnimation}
  //           animationDirection={animationDirection}
  //         />
  //       </div>
  //     </div>
  //     <div
  //       className={
  //         isArrowClick && animationDirection === 'bottom'
  //           ? 'header-arrow-container bg-yellow'
  //           : 'header-arrow-container bg-brand'
  //       }
  //       onClick={() => {
  //         if (completed === 0 && isActive && !isAudioPlaying) {
  //           onSkipClick('bottom')
  //           setAnimationDirection('bottom')
  //           setIsArrowClick(true)
  //         }
  //       }}
  //     >
  //       <NextOutline className='header-arrow-down-icon' />
  //     </div>
  //   </div>
  // )
}

export default HeaderCarousel
